module.exports = __webpack_public_path__ + "img/ETHNIC NECKLACE PURPLE.99879db.svg";